export default class NotaSaidaComProdutos {
  constructor(idRomaneio = "", idVendedor = "", dataSaida = "", dataRetorno = "", produtos = []) {
    this.IdRomaneio = idRomaneio
    this.IdVendedor = idVendedor
    this.DataSaida = dataSaida
    this.DataRetorno = dataRetorno
    this.Produtos = produtos
  }
}
